import styled from "styled-components";
import {FormControl, HStack} from "@chakra-ui/react"


export const StyleHStack = styled(HStack)`
   
  @media screen and (max-width: 670px) {
    flex-wrap: wrap;
  }

`

export const StyledFormControl = styled(FormControl)`

    @media screen and (max-width: 670px) {
      display: flex;
      flex-wrap: wrap-reverse;
  }

`

export const StyledFormControlMarge = styled(FormControl)`
        @media screen and (max-width: 670px) {
          margin-top: 2.1875rem;
  }
`